import { render, staticRenderFns } from "./processAssessmentModal.vue?vue&type=template&id=ca8ebcee&"
import script from "./processAssessmentModal.vue?vue&type=script&lang=js&"
export * from "./processAssessmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports